import { EventType } from '@/graphql/generated/schemas'
import { removeUnderscoreAndCapitalize } from '@/utils/formats'

import { EventsT } from '../types/types'

/**
 * Returns a formatted event name by capitalizing and removing underscores from the event type.
 * If the event type is 'Other' or null, attempts to use the ACS event type.
 * Returns 'Unknown' if neither type is available.
 *
 * @param event - The event object to extract the name from.
 * @returns The formatted event name or 'Unknown'.
 */
export const getEventName = (event: EventsT) => {
  if (event?.type !== EventType.Other && event?.type !== null) {
    return removeUnderscoreAndCapitalize(event?.type)
  }
  if (event?.acsEventType) {
    return removeUnderscoreAndCapitalize(event?.acsEventType)
  }
  return 'Unknown'
}
